const DOCUMENT = {
  PROOF_IDENTITY: 'PROOF_IDENTITY',
  INCOME_STATEMENT: 'INCOME_STATEMENT',
  PROOF_RESIDENCE: 'PROOF_RESIDENCE',
}

export { DOCUMENT }
